import script from "./CategoryTeaser.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryTeaser.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryTeaser.vue?vue&type=style&index=0&id=70671390&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70671390"]])

export default __exports__